import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_COMPANY } from "../../../../utils/constants";
import companyServices from "../../../../services/general/companyServices";
import { CompanyInterface } from "../../../../models/GeneralModule/Company";

interface AddCompanyContext {
  previousCompanies: CompanyInterface[];
}

const useAddCompany = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    CompanyInterface,
    Error,
    CompanyInterface,
    AddCompanyContext
  >({
    mutationFn: companyServices.Save,

    onMutate: () => {
      const previousCompanies =
        queryClient.getQueryData<CompanyInterface[]>([
          CACHE_KEY_COMPANY,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousCompanies };
    },

    onSuccess: (savedCompany) => {
      queryClient.setQueryData<CompanyInterface[]>(
        [
          CACHE_KEY_COMPANY,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (companies) =>
          companies ? [savedCompany, ...companies] : [savedCompany]
      );
    },

    onError: (error, newCompany, context) => {
      if (!context) return;

      queryClient.setQueryData<CompanyInterface[]>(
        [
          CACHE_KEY_COMPANY,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousCompanies
      );
    },
  });
};

export default useAddCompany;
